import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Component displayed when the user's organization is suspended
 * Blocks all application access and displays a message to contact admin
 */
export function SuspendedOrganization() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { tokens } = theme;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: tokens.core.spacing['4'].value,
        backgroundColor: tokens.semantic.color.background.base.value,
      }}
    >
      <Box
        sx={{
          maxWidth: '600px',
          textAlign: 'center',
          backgroundColor: tokens.semantic.color.background.container.value,
          padding: tokens.core.spacing['6'].value,
          borderRadius: tokens.semantic.radius.lg.value,
          boxShadow: tokens.semantic.shadow.focus.value.stringValue,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: tokens.semantic.font.title.h1Billboard.fontSize.value,
            lineHeight: tokens.semantic.font.title.h1Billboard.lineHeight.value,
            fontWeight: tokens.core.fontWeight.semiBold.value,
            color: tokens.semantic.color.type.default.value,
            marginBottom: tokens.core.spacing['4'].value,
          }}
        >
          {t('suspended_org.title')}
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            fontSize: tokens.semantic.font.text.body.fontSize.value,
            lineHeight: tokens.semantic.font.text.body.lineHeight.value,
            letterSpacing: tokens.semantic.font.text.body.letterSpacing.value,
            fontWeight: tokens.core.fontWeight.regular.value,
            color: tokens.semantic.color.type.muted.value,
          }}
        >
          {t('suspended_org.message')}
        </Typography>
      </Box>
    </Box>
  );
}
